import { useCallback } from 'react'

import { IContact } from 'clickNgo/entities/contact'
import { LoadingState } from 'clickNgo/entities/contact'
import { fetchContactRequestById } from 'clickNgo/entities/contact/api/fetchContactRequestById'
import { removeContactRequest } from 'clickNgo/entities/contact/api/request'
import { useGetFormDataField } from 'cng-common/features/form'
import { Nullable } from 'cng-common/models/utils'

import { ContactEditorFormKeys } from '../../../configs'
import { ContactEditorSettingFormFields, TContactEditorData } from '../../../models'

export const useRemoveRequest = (
  contact: IContact,
  onUpdate: (contact: Nullable<IContact>) => Promise<void> | void
) => {
  const [actualData, updateActualData] = useGetFormDataField<TContactEditorData>(
    ContactEditorFormKeys.settings,
    ContactEditorSettingFormFields.ActualData
  )
  const [, setErrorMessages] = useGetFormDataField<string[]>(
    ContactEditorFormKeys.settings,
    ContactEditorSettingFormFields.ErrorMessages
  )
  const [, setIsLoading] = useGetFormDataField<LoadingState>(
    ContactEditorFormKeys.settings,
    ContactEditorSettingFormFields.IsLoading
  )
  const removeRequest = useCallback(async () => {
    setIsLoading({ isLoading: true, message: 'Removing request...' })
    const isRemoved = await removeContactRequest(contact)
    const isNewContact =
      contact.contactId.startsWith('new-') || contact.contactId.startsWith('portal-')

    if (isRemoved) {
      if (isNewContact) {
        await onUpdate(null)
      } else {
        const newContact = await fetchContactRequestById(contact.contactId)

        if (newContact) {
          await onUpdate(newContact)
          updateActualData({
            ...actualData,
            contact: newContact,
          })
        } else {
          setErrorMessages([`Can't to update contact (${contact.contactId}), try to reload page.`])
        }
      }
    } else {
      setErrorMessages([`Can't to remove request. Try it again or contact with support.`])
    }

    setIsLoading({ isLoading: false, message: '' })
  }, [actualData, contact, onUpdate, setErrorMessages, setIsLoading, updateActualData])

  return { removeRequest }
}
